import InitApi from "api/InitApi";
import useTokenStore from "store/tokenStore";
import { useQuery } from "react-query";
import { deleteEmptyObjects, fetchConfig } from "utils";

const useGetAssignedOrders = (props) => {
	const { accessToken } = useTokenStore();
	const queryParams = props?.queryParams;
	const userId = props?.userId;

	const fetch = async () => {
		const instance = await InitApi({ accessToken });
		const params = queryParams ? deleteEmptyObjects(queryParams) : null;
		const url = userId ? `/orders/assigned/${userId}` : "/orders/assigned";
		const res = await instance.get(url, {
			params: { ...params },
		});
		return res.data?.data;
	};

	return useQuery(
		["orders", "assigned-orders", queryParams, userId],
		() => fetch(),
		{
			...fetchConfig,
		}
	);
};

export default useGetAssignedOrders;
